// extracted by mini-css-extract-plugin
export default {"reset-result":"reset-result_hRe7O","custom-btn":"custom-btn_PbPu0"};